import { useEffect } from 'react';

// While the send preview is open, every section outside the packet is marked,
// and the stylesheet hides it on screen and on paper. The marks come off when
// the preview closes, so the report is whole again. The DOM is the list, as it
// is for the meeting: nothing here keeps a second registry of sections.
export default function useSendPreview({ sending, include }) {
  useEffect(() => {
    const els = [...document.querySelectorAll('.asmt-doc > section[id]')];
    els.forEach(el => el.classList.toggle('asmt-send-out', sending && !include.has(el.id)));
    return () => els.forEach(el => el.classList.remove('asmt-send-out'));
  }, [sending, include]);
}
